// extracted by mini-css-extract-plugin
module.exports = {"document":"document_document__CHsaI"};